import { useCallback } from "react"
import { v4 as uuidv4 } from "uuid"
import { useAppDispatch } from "hooks/redux"
import { useDashboardId } from "../context/dashboard-id"
import { panelsSlice } from "../store/panels-slice"
import type { ModuleType, ModuleConfig } from "../modules/types"

/** Mirrors useRemoveModule — keeps callers free of UUID generation and dispatch boilerplate. */
export function useAddModule(): (payload: { type: ModuleType, config?: ModuleConfig }) => string {
  const dispatch = useAppDispatch()
  const dashboardId = useDashboardId()

  return useCallback(
    ({ type, config }: { type: ModuleType, config?: ModuleConfig }): string => {
      const id = uuidv4()
      dispatch(panelsSlice.actions.addModule({ dashboardId, id, type, config }))
      return id
    },
    [dispatch, dashboardId],
  )
}
